import {
  NEXT_PAGE_FAILURE,
  NEXT_PAGE_SUCCESS,
  NEXT_PAGE_REQUEST,
} from "../../constants";
import { createAction, createErrorAction } from "../../utils";

const domainSearchRequest = createAction(NEXT_PAGE_REQUEST);
const domainSearchSuccess = createAction(NEXT_PAGE_SUCCESS);
const domainSearchFailure = createErrorAction(NEXT_PAGE_FAILURE);

export const loadNextDomainsBatch = (nextUrl) => {
  return async (dispatch, getState, { api }) => {
    dispatch(domainSearchRequest());
    const keyword = getState().domains.keyword;

    // API call
    return api.getNextDomainsBatch(nextUrl).then(
      (data) => {
        dispatch(
          domainSearchSuccess({
            domains: data.data.domains,
            currency: data.data.currency,
            pagination: data.pagination,
            defaultIncludeVat: data.data.defaultIncludeVat,
            decimalSeparator: data.data.decimalSeparator,
            type: "all",
            keyword,
          }),
        );

        return true;
      },
      (err) => {
        dispatch(domainSearchFailure(err));
      },
    );
  };
};
